import Index from '../components/TipOrder/Index';

let routes = {
    path: '/tipOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/tipOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/tipOrder.js